<div class="assessment-container">
  <h2>Bowel Sounds</h2>
  <assessment-row title="Bowel Sounds RUQ" [historyMode]="true">
    <p>{{ data().bowelSoundsRuq }}</p>
  </assessment-row>
  <assessment-row title="Bowel Sounds RLQ" [historyMode]="true">
    <p>{{ data().bowelSoundsRlq }}</p>
  </assessment-row>
  <assessment-row title="Bowel Sounds LUQ" [historyMode]="true">
    <p>{{ data().bowelSoundsLuq }}</p>
  </assessment-row>
  <assessment-row title="Bowel Sounds LLQ" [historyMode]="true">
    <p>{{ data().bowelSoundsLlq }}</p>
  </assessment-row>

  <assessment-row title="Abnormal Bowel Movement" [historyMode]="true">
    <p>{{ data().abnormalBowelMovement }}</p>
  </assessment-row>
  <assessment-row title="Nausea" [historyMode]="true">
    <p>{{ data().nausea ? 'Yes' : 'No' }}</p>
  </assessment-row>
  <assessment-row title="Emesis" [historyMode]="true">
    <p>{{ data().emesis }}</p>
  </assessment-row>
  <assessment-row title="Incontinence" [historyMode]="true">
    <p>{{ data().incontinence ? 'Yes' : 'No' }}</p>
  </assessment-row>

  <h2>Ostomy</h2>
  <assessment-row title="Stoma Site" [historyMode]="true">
    <p>{{ data().ostomyStomaSite }}</p>
  </assessment-row>
  <assessment-row title="Output" [historyMode]="true">
    <p>{{ data().ostomyOutput }}</p>
  </assessment-row>

  <h2>Hemorrhoids</h2>
  <assessment-row title="Hemorrhoids" [historyMode]="true">
    <p>{{ data().hemorrhoids }}</p>
  </assessment-row>

  <h2>Nutrition</h2>
  <assessment-row title="Reduced Appetite" [historyMode]="true">
    <p>{{ isReducedAppetite }}</p>
  </assessment-row>
  <assessment-row title="Oral Diet" [historyMode]="true">
    <p>{{ data().oralDiet }}</p>
  </assessment-row>
  <assessment-row title="Tube Feed?" [historyMode]="true">
    <p>{{ isTubeFeed }}</p>
  </assessment-row>

  @if (data().tubeFeed) {
  <assessment-row title="Tube Type" [historyMode]="true">
    <p>{{ data().tubeType }}</p>
  </assessment-row>
  <assessment-row title="How many hours since bag changed?" [historyMode]="true">
    <p>{{ data().bagChangedHours }}</p>
  </assessment-row>
  <assessment-row title="Site Assessment" [historyMode]="true">
    <p>{{ data().siteAssessment }}</p>
  </assessment-row>
  }

  @if (patient().isPediatric()) {
  <assessment-row title="Abnormal Umbilical Cord" [historyMode]="true">
    <p>{{ data().abnormalUmbilicalCord ? 'Yes' : 'No' }}</p>
  </assessment-row>
  @if (data().abnormalUmbilicalCord) {
  <assessment-row title="Abnormality Details" [historyMode]="true">
    <p>{{ data().umbilicalCordDetails }}</p>
  </assessment-row>
  }
  }

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>
</div>